import { useState, useEffect } from 'react';

/**
 * Hook to manage mobile menu state and body overflow
 * @returns {Object} - Mobile menu state and functions
 */
const useMobileMenu = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle body overflow when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      if (document && document.body && document.body.style) {
        document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
      }
    } else {
      if (document && document.body && document.body.style) {
        document.body.style.overflow = ''; // Restore scrolling
      }
    }
    
    return () => {
      if (document && document.body && document.body.style) {
        document.body.style.overflow = ''; // Cleanup
      }
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return {
    isMobileMenuOpen,
    toggleMobileMenu,
    closeMobileMenu
  };
};

export default useMobileMenu;